import axiosRequest from "@/api/axios-optimize"

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics`, { params: data, ...config})
}

// 查找所有
export function findAll(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/findAll`, { params: data, ...config})
}

// 获取商品列表
export function getGoodsList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/goods`, { params: data, ...config})
}

// 获取首页库存统计
export function getDashboardData(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getDashboardData`, { params: data, ...config})
}

// 获取库存预警列表
export function getSpuWarningList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/spuWarning/list`, { params: data, ...config})
}

// 获取过期预警列表
export function getExpireWarningList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/expireWarning/list`, { params: data, ...config})
}

// 获取一级仓库对应库存数量
export function getWareHouseGoodsCount(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getWareHouseGoodsCount`, { params: data, ...config})
}

// 获取生产入库数据
export function getInventoryStatistics(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getInventoryStatistics`, { params: data, ...config})
}

// 获取七天内的销售出库数据
export function getSevenDaySaleOutData(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getSevenDaySaleOutData`, { params: data, ...config})
}

// 获取七天内的过期出库数据
export function getSevenDayExpireOutData(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getSevenDayExpireOutData`, { params: data, ...config})
}

// 获取七天内的退货入库数据
export function getSevenDayReturnEntryData(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getSevenDayReturnEntryData`, { params: data, ...config})
}

// 获取七天内的移库数据
export function getSevenDayMoveData(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/statistics/getSevenDayMoveData`, { params: data, ...config})
}

// 修改过期预警邮件通知
export function changeExpireEmailWarning(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/expireWarning/changeExpireEmailWarning`, data, config)
}

// 修改过期预警邮件通知
export function changeInventoryEmailWarning(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/spuWarning/changeInventoryEmailWarning`, data, config)
}

// 获取外借商品列表
export function getLendList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out/lend`, { params: data, ...config})
}

// 批量催还商品
export function batchUrgeReturn(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/out/batchUrgeReturn`, data, config)
}

// 获取销售/促销出库商品列表
export function getSalesList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out/sales`, { params: data, ...config})
}

// 获取过损出库商品列表
export function getDamageList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out/damage`, { params: data, ...config})
}

// 获取退货入库商品列表
export function getReturnGoodsList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/return-goods`, { params: data, ...config})
}

// 获取归还入库商品列表
export function getReturnList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/return`, { params: data, ...config})
}

// 获取生产入库商品列表
export function getProduceList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/produce`, { params: data, ...config})
}

// 获取采购入库商品列表
export function getPurchaseList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/purchase`, { params: data, ...config})
}

